import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../formConfig';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateAppUpdateInfo, getLudoVersionNumberOptions } = useService();

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MAX_VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MIN_VERSION].setRenderProps({ getOptions: getLudoVersionNumberOptions });

	const cloneWebsiteUpdateInfo = async (clonedData: any) => {
		setShowLoader(true);
		try {
			await requestCreateAppUpdateInfo(clonedData);
			showAlert('Apk version created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(true);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneWebsiteUpdateInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
